import axios from 'axios'

const GronerWrapper = {
  postToGroner: (subdomain, endpoint, payload) => {
    return new Promise((resolve, reject) => {
      let url = `https://${subdomain}.api.safeleads.app/api/${endpoint}`
      let config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return axios.post(url, payload, config).then(({ data }) => {
        return resolve(data)
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getToken: (subdomain, email, password) => {
    return new Promise((resolve, reject) => {
      const payload = {
        email,
        senha: password
      }
      return GronerWrapper.postToGroner(
        subdomain,
        'Conta/GerarToken',
        payload
      ).then(({ Content }) => {
        const { accessToken, created, expiration, funcao, nome, perfil, perfilid, usuarioid } = Content
        return resolve({ accessToken, created, expiration, funcao, nome, perfil, perfilid, usuarioid })
      }).catch(err => {
        return reject(err)
      })
    })
  }
}

export default GronerWrapper



// WEBPACK FOOTER //
// ./src/services/groner-wrapper.js